import "core-js/modules/es.array.fill.js";
export var dropdownPortalTokens = {
  item: {
    sizes: {
      s: {
        paddingX: 10,
        paddingY: 6
      },
      m: {
        paddingX: 12,
        paddingY: 7
      },
      l: {
        paddingX: 14,
        paddingY: 8
      }
    },
    colors: {
      bgSelected: function bgSelected(_ref) {
        var color = _ref.color;
        return color.fill.item.selected;
      },
      bgHighlighted: function bgHighlighted(_ref2) {
        var color = _ref2.color;
        return color.fill.item.hover;
      },
      bgBase: function bgBase(_ref3) {
        var color = _ref3.color;
        return color.fill.item.base;
      },
      bgHover: function bgHover(_ref4) {
        var color = _ref4.color;
        return color.fill.item.hover;
      }
    }
  },
  menu: {
    maxHeight: 300,
    borderRadius: 6,
    bgColor: function bgColor(_ref5) {
      var color = _ref5.color;
      return color.fill.item.base;
    },
    boxShadow: function boxShadow(_ref6) {
      var shadows = _ref6.shadows;
      return shadows.level1;
    }
  },
  group: {
    titleColor: function titleColor(_ref7) {
      var color = _ref7.color;
      return color.text.placeholder.base;
    },
    marginBottom: "4px",
    titleFontSize: "xs",
    separatorColor: function separatorColor(_ref8) {
      var color = _ref8.color;
      return color.border.hr.base;
    },
    separatorHeight: "1px",
    paddingY: "16px"
  }
};